/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { AccommodationApiDto } from '../model/accommodation.model';
// @ts-ignore
import { DefaultErrorMessageApiDto } from '../model/default-error-message.model';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';
import { AccommodationsControllerApiServiceInterface } from './accommodations-controller.serviceInterface';

@Injectable({
  providedIn: 'root',
})
export class AccommodationsControllerApiService extends BaseService implements AccommodationsControllerApiServiceInterface {
  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string | string[], @Optional() configuration?: Configuration) {
    super(basePath, configuration);
  }

  /**
   * @param schoolId
   * @param courseId
   * @param acceptLanguage Language code to inform the display language for the results
   * @param acceptCompany Company code for the source of data
   * @param tripDate
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findAccommodationsByCourse(
    schoolId: number,
    courseId: number,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    tripDate?: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<AccommodationApiDto>>;
  public findAccommodationsByCourse(
    schoolId: number,
    courseId: number,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    tripDate?: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<AccommodationApiDto>>>;
  public findAccommodationsByCourse(
    schoolId: number,
    courseId: number,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    tripDate?: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<AccommodationApiDto>>>;
  public findAccommodationsByCourse(
    schoolId: number,
    courseId: number,
    acceptLanguage: string,
    acceptCompany: 'ALP' | 'KIL' | 'PL' | 'ESL',
    tripDate?: string,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    if (schoolId === null || schoolId === undefined) {
      throw new Error('Required parameter schoolId was null or undefined when calling findAccommodationsByCourse.');
    }
    if (courseId === null || courseId === undefined) {
      throw new Error('Required parameter courseId was null or undefined when calling findAccommodationsByCourse.');
    }
    if (acceptLanguage === null || acceptLanguage === undefined) {
      throw new Error('Required parameter acceptLanguage was null or undefined when calling findAccommodationsByCourse.');
    }
    if (acceptCompany === null || acceptCompany === undefined) {
      throw new Error('Required parameter acceptCompany was null or undefined when calling findAccommodationsByCourse.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>schoolId, 'schoolId');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>courseId, 'courseId');
    localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>tripDate, 'tripDate');

    let localVarHeaders = this.defaultHeaders;
    if (acceptLanguage !== undefined && acceptLanguage !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Language', String(acceptLanguage));
    }
    if (acceptCompany !== undefined && acceptCompany !== null) {
      localVarHeaders = localVarHeaders.set('Accept-Company', String(acceptCompany));
    }

    const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/products/v1/accommodations`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<AccommodationApiDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
